<template>
  <div class="userCenter">
    <label
      data-v-8dc25710=""
      class="con_title_text"
    ><span
      data-v-8dc25710=""
      class="topright icon"
    ></span><span
      data-v-8dc25710=""
      class="fs_21"
    >USER CENTER</span><span
      data-v-8dc25710=""
      class="fs_21 cn"
    >{{ TLang('个人中心','my') }}</span><span
      data-v-8dc25710=""
      class="bottomleft icon"
    ></span></label>
    <div
      data-v-8dc25710=""
      class="con_title_line"
    >
      <div
        data-v-8dc25710=""
        class="blue"
      ></div><div
        data-v-8dc25710=""
        class="black"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BFDUserCneter',
};
</script>

<style lang="less">
.userCenter {
  margin-bottom: 15px;
  .con_title_text {
      position: relative;
      margin: 6px 12px 15px;
      display: inline-block;

    .icon {
      background: url(../../../../../assets/images/common_icon.png) no-repeat;
      display: block;
      width: 17px;
      height: 17px;
    }


    .topright {
      position: absolute;
      right: -14px;
      top: -5px;
    }

    .fs_21 {
      font-weight: 700;
      font-size: 21px!important;
    }

    .bottomleft {
      position: absolute;
      background-position: -29px 0!important;
      top: 16px;
      left: -12px;
    }

    .cn {
      color: #e5152e;
    }
  }
  .con_title_line {
    position: relative;
    overflow: hidden;

    .blue {
      width: 100px;
      border-bottom: 5px solid #1a4a9e;
      position: absolute;
      -webkit-transform: skewX(-20deg);
      -ms-transform: skewX(-20deg);
      transform: skewX(-20deg);
      left: -2px;
    }

    .black {
      width: 100%;
      border-bottom: 5px solid #323232;
    }
  }
}
</style>